import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-credit-note-monthwise-register',
  templateUrl: './credit-note-monthwise-register.component.html',
  styleUrl: './credit-note-monthwise-register.component.scss'
})
export class CreditNoteMonthwiseRegisterComponent {


   CreditNoteForm: any;
    reportType: any;
    advtName: any;
    issueDates: any;
  
    currentDate = new Date();
     constructor(
        private dialogRef: MatDialogRef<CreditNoteMonthwiseRegisterComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
      ) {
      }

  CreditNoteMFormBeans: any = []
  repName: any;
  startDate: any;
  endDate: any;
  offRepName: any;
  CreditadvtOffMTotal: number;
  issueDates1: any;

  CreditadvtOffMTDS = 0;
CreditadvtOffMOther = 0;
// CreditadvtOffMTotal = 0;


  ngOnInit(): void {

  debugger
  let repname: any = this.data['repName'];
  
      // Then check if it's not empty and convert to array
      if (repname != "") {
        repname = repname; // This puts the single value in an array
      }
  
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      this.issueDates1 = this.data['issue_date'];

  // getCreditNoteM() {

    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_name": ""
    }
    // this.service.getCreditNoteM(req).subscribe((data: any) => {
    //   console.log("ADVT Data=", data);
    //   this.CreditNoteMFormBeans = (data as any);

    //   // Reset totals
    //   this.CreditadvtOffMTotal = 0;

    //   // Calculate totals
    //   for (let data of this.CreditNoteMFormBeans) {

    //     this.CreditadvtOffMTotal += parseFloat(data.total_amt) || 0;
    //   }

    // });
  // }


this.service.getCreditNoteM(req).subscribe((data: any) => {
  console.log("ADVT Data=", data);
  this.CreditNoteMFormBeans = data;

  // Reset totals
  this.CreditadvtOffMTDS = 0;
  this.CreditadvtOffMOther = 0;
  this.CreditadvtOffMTotal = 0;

  // Calculate totals
  for (let item of this.CreditNoteMFormBeans) {
    this.CreditadvtOffMTDS += parseFloat(item.tds_amt) || 0;
    this.CreditadvtOffMOther += parseFloat(item.other_credit_amt) || 0;
    this.CreditadvtOffMTotal += parseFloat(item.total_amt) || 0;
  }
});


  }


exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}

}
